(function() {
    'use strict';
    
a3_cabin_reports.factory('FlightOrdersFactory', FlightOrdersFactory);
    /**
    * @memberof CabinReports
    * @ngdoc factory
    * @name FlightOrdersFactory
    * @description 
    * Get selected flight info
    * @ngInject
    */ 
function FlightOrdersFactory($http, apiUrl, GenericService, CabinReportLocalEditFactory, $injector, PaxInfoFactory, FlightFactory) {
    
    var service = {
        getFlightOrders: getFlightOrders,
        //getFlightOrdersByFlightIdFromLS: getFlightOrdersByFlightIdFromLS, //use getFlightOrdersFlattenedByFlightId
        upsertFlightOrders: upsertFlightOrders,
        cleanOldDataFlightOrders: cleanOldDataFlightOrders,
        getFlightOrdersForCreateReportByFlightId: getFlightOrdersForCreateReportByFlightId,
        getFlightOrdersFlattenedByFlightId: getFlightOrdersFlattenedByFlightId,
        getNotDeliveredReasons: getNotDeliveredReasons,
        saveOrUpdateCabinReport: saveOrUpdateCabinReport,
        setFlightOrders: setFlightOrders
    };

    /**
    * Initialize the FlightOrder 
    * @memberof FlightOrdersFactory
    */
    function FlightOrder() {
        this.FlightId = null;
        this.FlightDate = null;
        this.FlightNumber = null;
        this.DepartureAirport = null;
        this.Orders = null;
    }
    var objFlightOrder = 'flightOrders';
    var objFlightOrderCallback = FlightOrder;

    /**
     * Save flight orders
     * @memberof FlightOrdersFactory
     * @param {Array} flight orders
     */
    function setFlightOrders(orders) {
        // Validate and filter orders
        const validOrders = orders.filter(order => order && order.FlightId);   
        // Save orders using GenericService
        GenericService.saveAll(validOrders, objFlightOrder);
    }
    

    /**
     * Get Event Types
     * @memberof FlightOrdersFactory
     * @returns {Array} flight orders 
     */
     function getFlightOrders() {
        // Retrieve orders from GenericService
        const storedOrders = GenericService.list(objFlightOrder, objFlightOrderCallback);
       
        // Filter valid orders
        return storedOrders ? storedOrders.filter(order => order && order.FlightId) : [];
    }
    
    function getFlightOrdersFlattenedByFlightId(flightId) {
        // Retrieve stored orders
        const storedOrders = getFlightOrders();
    
        // Retrieve the current report
        const report = CabinReportLocalEditFactory.getCabinReportLocalEditForFlight(flightId);
    
        // If a report exists, use its orders as the source of truth
        if (report && report.FlightOrders) {
            return {
                FlightId: flightId,
                Orders: report.FlightOrders.Orders
            };
        }
    
        // Fallback to stored orders
        if (storedOrders) {
            const allOrdersForTheFlight = storedOrders.filter(x => x.FlightId == flightId);
            const flattenedOrders = allOrdersForTheFlight.reduce((acc, flightOrder) => acc.concat(flightOrder.Orders), []);
    
            return {
                FlightId: flightId,
                Orders: flattenedOrders
            };
        }
    
        return null; // No data available
    }
    

    function upsertFlightOrders(orders, responseFlightIds) {
        responseFlightIds.forEach(function(flightId){
            //Find SeatNo from seatMap
            PaxInfoFactory.getPaxInfoList(flightId, function (passengerList) {
                //console.log(orders);
                if(passengerList && orders){
                    orders.forEach(function (flightOrder){
                        if(flightOrder.Orders){
                            flightOrder.Orders.forEach(function (order) {
                                if (order) {
                                    var matchedPassenger = passengerList.filter(x =>
                                        (x.PNR == order.Passenger.PNR && x.Fullname.toUpperCase().includes(order.Passenger.FirstName.toUpperCase()))
                                    );
                                    if (matchedPassenger && matchedPassenger.length > 0) {
                                        order.Passenger.Seat  = matchedPassenger[0].SeatNo;
                                    }
                                }
                            });
                        }
                    });
                }
                //store to localdb
                var storedOrders = getFlightOrders();  
                if(storedOrders){
                    var otherOrders = storedOrders.filter(x => !responseFlightIds.includes(x.FlightId));
                    var mergeEvents = otherOrders.concat(orders);
                    setFlightOrders(mergeEvents);
                } else{
                    setFlightOrders(orders);
                }
            });
        })
    }

    function cleanOldDataFlightOrders(responseFlightIds) {    
        var storedOrders = getFlightOrders();  
        if (storedOrders) {
            // Filter out null or invalid entries before proceeding
            var validStoredOrders = storedOrders.filter(order => order && order.FlightId);
            var previousOrders = validStoredOrders.filter(x => responseFlightIds.includes(x.FlightId));
            setFlightOrders(previousOrders);
        } 
    }
    
    function getFlightOrdersForCreateReportByFlightId(flightId){
        var flightOrders = null;
        var flightOrdersLS = getFlightOrdersFlattenedByFlightId(flightId);
        if(flightOrdersLS){
            flightOrdersLS.Orders.forEach(function (order) {
                //add report properties
                if (order) {
                    order.Status = 'Pending';
                    order.Feedback = '';
                    order.Reason = '';
                    //for the photo modal
                    order.Photos = [];
                    order.Label = 'Shop In The Cloud';
                }
            });
            flightOrders = flightOrdersLS;
        }
        return flightOrders;
    }

    function getNotDeliveredReasons(){
        return ['Pax no-show', 'Pax refused to receive', 'Wrong/incomplete order', 'Damaged/Defective product/s', 'Order not loaded'];
    }

    function saveOrUpdateCabinReport(flightId, flattenedOrders) {    
        try {   
            let report = CabinReportLocalEditFactory.getCabinReportLocalEditForFlight(flightId);
    
            // Check if the flight status is pending or pending overdue
            const flight = FlightFactory.getFlightFromStorage(flightId);
            if (!flight) {
                return;
            }
         
            if (flight.LineStatus === 'pending' || flight.LineStatus === 'pendingoverdue') {       
                const CabinReportLocalEditCreatorFactory = $injector.get('CabinReportLocalEditCreatorFactory');
                report = CabinReportLocalEditCreatorFactory.createNewLocalReportForFlight(flightId);
   
                report.Status = 'draft';
    
                // Save the report using a method on the report object if it exists
                if (report.saveReport) {
                    report.saveReport();
                }
    
                // Update the flight with details from the new report
                FlightFactory.updateFlightFromReport(report);
            }
    
            // Merge stored and updated orders
            const allOrders = flattenedOrders.Orders.map(order => {
                const existingOrder = report && report.FlightOrders && report.FlightOrders.Orders
                    ? report.FlightOrders.Orders.find(o => o.OrderNumber === order.OrderNumber)
                    : null;
                return existingOrder ? { ...existingOrder, ...order } : order;
            });
            if (!report.FlightOrders) {
                report.FlightOrders = { Orders: [] };
            }

            report.FlightOrders.Orders = allOrders;
    
            // Save report to local storage
            CabinReportLocalEditFactory.setCabinReportToStorage(report);
    
            // Verify that the report was saved
            const savedReport = CabinReportLocalEditFactory.getCabinReportLocalEditForFlight(flightId);
    
            // Sync with Flight Orders Storage
            setFlightOrders([{ FlightId: flightId, Orders: allOrders }]);
    
        } catch (error) {
            console.error("Error in saveOrUpdateCabinReport:", error);
        }
    }
    
    return service;
}
})();